exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.PopupSectionInfo_container_36mU {\n  margin: 16px 0;\n  padding: 16px 0;\n\n  border-top: 1px solid #bebec9;\n  border-bottom: 1px solid #bebec9;\n}\n.PopupSectionInfo_component_BNCO {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"container": "PopupSectionInfo_container_36mU",
	"component": "PopupSectionInfo_component_BNCO"
};